<template>
  <div class="footer" v-if="showFooter">
    <div class="description-wrapper">
      <img
        src="../assets/images/security-logo.png"
        alt="security"
        class="security-logo"
      />
      <div class="description" @click="toggle">
        Your security is our top priority. We adhere to
        <b>PCI-DSS</b> standards, ensuring that your payment information is
        processed, stored and transmitted securely.
        <a
          class="link footer-link"
          href="https://sidpayment.com/security/"
          target="_blank"
          >Find Out More</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  data() {
    return {
      extended: false,
    }
  },
  computed: {
    ...mapState('transaction', ['showBodyOnly', 'transaction']),
    ...mapState('merchantSettings', ['merchantBanks']),
    showFooter() {
      return (
        this.transaction != null &&
        this.merchantBanks.length > 0 &&
        !this.showBodyOnly
      )
    },
  },
  methods: {
    toggle() {
      this.extended = !this.extended
    },
  },
}
</script>

<style scoped lang="scss">
.footer {
  @media screen and (max-width: $mobile-resolution) {
    padding-bottom: 34px;
  }

  & a {
    text-decoration: none;
  }
}

.description-wrapper {
  padding: 16px 94px;
  border-top: 1px solid #d8d8d8;
  text-align: center;
  bottom: 0;

  .description {
    font-size: 12px;
    color: #4a4a4a;
    margin-top: 15.5px;
  }

  @media screen and (max-width: $mobile-resolution) {
    padding: 16px;
  }
}

.extended-description {
  width: 100%;
  padding: 16px;
  font-size: 12px;
  color: #4a4a4a;
  border-top: 1px solid #d8d8d8;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
  text-align: center;

  @media screen and (max-width: $mobile-resolution) {
    border-radius: 0;
    padding-bottom: 10%;
  }
}

.footer-link {
  display: inline;

  @media screen and (max-width: $mobile-resolution) {
    display: block;
    font-size: 16px;
    margin-top: 4px;
  }
}

.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.5s ease-in-out;
}

.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
}
</style>
